import StudentDashboardLayout from "@/components/Student/DashboardLayout";
import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css"; // Import the CSS for styling
import { useAuthContext } from "@/context/auth/AuthContext";
import axios from "axios";
import Link from "next/link";
import Wishlist from "@/components/Student/Wishlist";
import SessionsCalendar from "@/components/Student/SessionsCalendar";
import LastWatched from "@/components/Student/dashboard/LastWatched";
import { connectToDatabase } from "@/components/Server/Database/MongoDB";

const StudentDashboard = ({ info }) => {
  const [performanceScore, setPerformanceScore] = useState([]);
  const { user } = useAuthContext();

  useEffect(() => {
    const fetchPerformanceScore = async () => {
      if (user) {
        try {
          const response = await axios.get(
            `/api/video/subjects/?userId=${user.email}&limit=100`
          );

          if (response.status === 200) {
            const performance = response.data.data.reduce((prev, curr) => {
              return curr.progressValue + prev;
            }, 0);
            setPerformanceScore(performance / response.data.data.length || 0);
          } else {
            console.error("Error fetching data");
          }
        } catch (err) {
          console.error("Fetch data error:", err);
        }
      }
    };
    fetchPerformanceScore();
  }, [user]);

  return (
    <StudentDashboardLayout brand={JSON.parse(info)} sidebar={true}>
      <div className="rbt-dashboard-content bg-color-white rbt-shadow-box mb--10">
        <div className="content">
          <div className="section-title">
            <h4 className="rbt-title-style-3">Dashboard</h4>
          </div>

          <div className="rbt-progress-style-1 mb--10">
            <div className="single-progress">
              <h6 className="title">Your Total Performance</h6>
              <div className="progress">
                <div
                  className="progress-bar wow fadeInLeft"
                  data-wow-duration="0.5s"
                  data-wow-delay=".3s"
                  role="progressbar"
                  style={{
                    width: `${Number(performanceScore * 100).toFixed(2)}%`,
                  }}
                  aria-valuenow={performanceScore * 100}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
                <Link href={`/student/student-performance`}>
                  <span className="progress-number">
                    {Number(performanceScore * 100).toFixed(2)}% -{" "}
                    <i className="feather-eye" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className=" mt--10 mb--10 col-12">
              <SessionsCalendar />
            </div>
            <div className="col-md-6 mt--10 mb--10 col-12">
              <LastWatched />
            </div>
            <div className="col-md-6 mt--10 mb--10 col-12">
              <Wishlist col="col-12" />
            </div>
          </div>
        </div>
      </div>
    </StudentDashboardLayout>
  );
};

export const getServerSideProps = async (context) => {
  const domainName = context.req ? context.req.headers.host : null;

  const { db } = await connectToDatabase();

  const info = await db.collection("partners").findOne({
    key: process.env.DEFAULT || domainName,
  });

  if (!info) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      info: JSON.stringify(info),
    },
  };
};
export default StudentDashboard;
